export default __webpack_public_path__ + "static/media/ISMO CLASS-10 EXAM PATTERN 2025.bf046d8b.pdf";